import { useState, useEffect } from "react";
import Seo from "../components/Seo";
import SectionHeader from "../components/SectionHeader";
import SponsorenGrid from "../components/SponsorenGrid";
import CtaSection from "../components/CtaSection";
import { fetchSponsoren } from "../cms/sponsoren";

const vorteile = [
  {
    titel: "Sichtbarkeit",
    text: "Logo-Präsenz auf der Website, an Spieltagen und auf Trikots — wahrnehmbar bei Spielern, Eltern und Zuschauern.",
  },
  {
    titel: "Regionale Verankerung",
    text: "Assoziierung mit einem erfolgreichen, positiv wahrgenommenen Nachwuchsprojekt in der Region.",
  },
  {
    titel: "Nachwuchsförderung",
    text: "Als Sponsor unterstützen Sie aktiv die Förderung junger Talente aus der Region — ein Engagement mit echtem gesellschaftlichem Mehrwert.",
  },
];

export default function Sponsoren() {
  const [sponsoren, setSponsoren] = useState([]);
  const [loading, setLoading]     = useState(true);

  useEffect(() => {
    fetchSponsoren()
      .then(setSponsoren)
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Seo
        title="Sponsoren"
        description="Unsere Partner und Unterstützer — werden Sie Teil des Team Sempachersee."
        path="/sponsoren"
      />

      {/* Page-Header */}
      <section className="bg-primary text-white">
        <div className="mx-auto max-w-6xl px-4 py-16">
          <p className="text-accent font-bold uppercase tracking-widest text-xs mb-3">Gemeinsam stark</p>
          <h1 className="text-5xl md:text-6xl font-extrabold uppercase">Sponsoren</h1>
          <p className="mt-4 text-white/80 max-w-xl text-lg">
            Sponsoring beim TSS verbindet Ihr Unternehmen mit Nachwuchsfussball auf höchstem regionalem Niveau.
          </p>
        </div>
      </section>

      {/* Sponsoren-Grid */}
      <section className="mx-auto max-w-6xl px-4 py-16">
        <SectionHeader
          eyebrow="Unsere Partner"
          title="Danke für die Unterstützung"
          text="Diese Unternehmen und Organisationen machen unsere Arbeit erst möglich."
        />
        {loading ? (
          <div className="grid grid-cols-3 md:grid-cols-5 gap-6">
            {[1,2,3,4,5].map((n) => (
              <div key={n} className="bg-dark/5 animate-pulse h-24" />
            ))}
          </div>
        ) : (
          <SponsorenGrid sponsoren={sponsoren} />
        )}
      </section>

      {/* Warum Sponsoring */}
      <section className="bg-light">
        <div className="mx-auto max-w-6xl px-4 py-16">
          <SectionHeader eyebrow="Ihr Mehrwert" title="Warum TSS-Sponsor?" />
          <div className="grid gap-6 sm:grid-cols-3">
            {vorteile.map((v) => (
              <div key={v.titel} className="bg-white p-7 border border-black/5 shadow-sm">
                <div className="h-1 w-10 bg-accent mb-5" />
                <h3 className="text-lg font-bold uppercase">{v.titel}</h3>
                <p className="mt-3 text-sm text-dark/70 leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaSection
        title="Interesse an einem Sponsoring?"
        text="Sprechen Sie die Gruppierungsleitung direkt an oder nutzen Sie das Kontaktformular — wir zeigen Ihnen gerne die Möglichkeiten."
        ctaLabel="Sponsoring anfragen"
        ctaTo="/kontakt"
      />
    </>
  );
}
